import { useFetchData } from "../../../hooks/useFetch";
import { ApiConfig,API_DRIVER_ROUTER,API_USER_ROUTER } from "../../../services/api-config";

export enum UserStatusCode {
  INACTIVE = 0,
  ACTIVE = 1,
}

export interface User {
  id: number;
  username?: string;
  department_id?: number;
  name: string;
  email: string;
  phone: string;
  password?: string; // optional: show in detail when available
  privilege_group_id?: number;
  privilege_group_name?: string;
  address?: string;
  avatar?: string;
  gender?: number;
  joining_date?: string;
  birthday?: string;
  id_card_number?: string;
  identity_card?: string;
  status: UserStatusCode;
  created_at: string;
  updated_at: string;
  branches?: Array<{
    id: number;
    name: string;
    address?: string;
    phone?: string;
    status?: number;
  }>;
  company_id?: number;
  log_company_id?: number;
  is_all_branch?: number; // 1 = tất cả đại lý, 0 = chỉ một số
  is_2fa?: number;        // 1 = bật, 0 = tắt
  department_name?: string
  is_external ?: number
}

export interface UserListFilters {
  status?: number; // 1 active, 0 inactive, -1 all
  key_search?: string;
  department_id?: number;
  is_driver?: number;
  page?: number;
  limit?: number;
}

export interface UserListResponse {
  list: User[];
  total_record?: number;
  limit?: number;
}

export interface CountTabsResponse {
  active: number;
  inactive: number;
}

export interface CreateUserPayload {
  username: string;
  department_id?: number;
  privilege_group_id?: number;
  name: string;
  email: string;
  phone: string;
  password: string;
  address?: string;
  avatar?: string;
  gender?: number;
  joining_date?: string;
  birthday?: string;
  id_card_number?: string;
  status?: UserStatusCode;
  branch_id?: number;
  is_external?: number
}

export interface UpdateUserPayload {
  username?: string;
  department_id?: number;
  privilege_group_id?: number;
  name: string;
  email: string;
  phone: string;
  password?: string;
  address?: string;
  avatar?: string;
  gender?: number;
  joining_date?: string;
  birthday?: string;
  id_card_number?: string;
  status?: UserStatusCode;
  is_external?: number
}

export interface ChangeStatusPayload {
  status: UserStatusCode;
}

export interface ResetPasswordPayload {
  id: number;
}

const DriverService = {
  list: () => {
    const { request, baseResponse, loading } = useFetchData.Get<UserListResponse>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: (params: UserListFilters = { status: -1,key_search: "" }) => {
        const queryParams = {
          status: params.status,
          key_search: params.key_search,
          department_id: params.department_id,
          is_driver: params.is_driver,
          page: params.page ?? 1,
          limit: params.limit ?? 20,
        };
        return request({
          endPoint: API_DRIVER_ROUTER.API_LIST,
          data: queryParams,
        });
      },
      response: baseResponse,
      loading: loading,
    }
  },
  create: () => {
    const { request, baseResponse, loading } = useFetchData.Post<User>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: (payload: CreateUserPayload) =>
        request({
          endPoint: API_DRIVER_ROUTER.API_CREATE,
          data: payload,
        }),
      response: baseResponse,
      loading: loading,
    }
  },

  update: () => {
    const { request, baseResponse, loading } = useFetchData.Post<User>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return{
      fetch: (id: number, payload: UpdateUserPayload) =>
        request({
          endPoint: API_DRIVER_ROUTER.API_UPDATE(id),
          data: payload,
        }),
      response: baseResponse,
      loading: loading
    }
  },

  changeStatus: () => {
    const { request, baseResponse, loading } = useFetchData.Post<User>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: (id: number, payload: ChangeStatusPayload) =>
        request({
          endPoint: API_DRIVER_ROUTER.API_CHANGE_STATUS(id),
          data: payload,
        }),
      response: baseResponse,
      loading: loading,
    }
  },

  detail: () => {
    const { request, baseResponse, loading } = useFetchData.Get<User>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: (id: number) =>
        request({
          endPoint: API_DRIVER_ROUTER.API_DETAIL(id),
        }),
      response: baseResponse,
      loading: loading,
    }
  },

  resetPassword: () => {
    const { request, baseResponse, loading } = useFetchData.Post<User>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: (id: number) =>
        request({
          endPoint: API_USER_ROUTER.API_RESET_PASSWORD(id),
          data: {},
        }),
      response: baseResponse,
      loading: loading,
    }
  },
};

export default DriverService;
